import React, { useState, useEffect, useRef, useContext } from "react";
import { Dialog, Toast } from "primereact";
import { Button } from "primereact/button";
import { Carousel } from "primereact/carousel";
import { FileUpload } from "primereact/fileupload";

import Loader from "../Loader/Loader";
import Card from "../Card/Card";

const ImagenCRUD = ({
  fileUpload,
  showDialogFoto,
  setShowDialogFoto,
  getInfo,
  selected,
  setSelected,
  subirArchivo,
  getArchivos,
  descargar,
  eliminar,
  showDialogEliminar,
  setShowDialogEliminar,
  setEliminarFoto,
  loading,
  imagenes,
  listadoArchivos,
  title,
}) => {
  const toast = useRef(null);
  const [showModalImagenes, setShowModalImagenes] = useState(false);

  const onHide = () => {
    setShowDialogFoto(false);
    getInfo();
    setSelected([]);
  };

  const eliminarImagenn = (a) => {
    setShowDialogEliminar(true);
    setEliminarFoto(a);
  };

  useEffect(() => {
    if (showDialogFoto) {
      getArchivos();
    }
  }, [showDialogFoto]);

  const DialogFooter = (
    <React.Fragment>
      <Button
        label="Cancelar"
        icon="pi pi-times"
        className="p-button-text"
        onClick={() => {
          setShowDialogEliminar(false);
          setEliminarFoto([]);
        }}
      />
      <Button
        label={"OK"}
        icon="pi pi-check"
        className="p-button-text"
        onClick={() => {
          eliminar();
        }}
      />
    </React.Fragment>
  )

  return (
    <div>
      <Dialog
        visible={showDialogFoto}
        onHide={onHide}
        header={title}
        style={{ width: "60%" }}
      >
        <Toast ref={toast} />
        <div className="d-flex" id="Dialog">
          <div style={{ width: "60%" }} className="mt4">
            <Loader loading={loading} querySelector={"#Dialog"} />

            <FileUpload
              ref={fileUpload}
              name="demo"
              url="./upload"
              // multiple
              customUpload
              uploadHandler={subirArchivo}
              maxFileSize={40000000}
            />

            <div className="mt-3">
              <div>
                {listadoArchivos?.map((a, i) => (
                  <div
                    className="d-flex gap p-2 border mt-2"
                    style={{ alignItems: "center" }}
                    key={i}
                  >
                    <div className="col-10">{a}</div>
                    <Button
                      icon="pi pi-download"
                      onClick={() => descargar(a)}
                    />
                    <Button
                      icon="pi pi-trash"
                      severity="danger"
                      onClick={() => eliminarImagenn(a)}
                    />
                  </div>
                ))}
              </div>
            </div>
          </div>
          <div style={{ width: "40%" }}>
            <Card
              style={{ height: "100%", marginTop: 0 }}
              contenido={
                <div>
                  {!imagenes.img && (<h5>No se han agregado imágenes.</h5>)}

                  {imagenes.Codigo && (
                    <Carousel
                      value={imagenes.img}
                      showIndicators={true}
                      itemTemplate={(item) => {
                        return (
                          <div className="d-flex" style={{ justifyContent: "center", alignItems: "center", height: "400px" }}>
                            <img
                              src={"data:image/png;base64," + item}
                              alt="imagen"
                              style={{ maxWidth: "80%", maxHeight: "100%", objectFit: "contain" }}
                              onClick={()=> setShowModalImagenes(true)}
                            />
                          </div>
                        );
                      }}
                    />
                  )}
                </div>
              }
            />
          </div>
        </div>
      </Dialog>

      <Dialog
        visible={showDialogEliminar}
        onHide={() => {
          setShowDialogEliminar(false);
          setEliminarFoto([]);
        }}
        header={"Eliminar"}
        footer={DialogFooter}
        style={{ width: "30%" }}
      >
        <div id="Dialog">
          <h4>¿Estás seguro de eliminar?</h4>
        </div>
      </Dialog>

      <Dialog
        header={selected[0]?.NombreCompleto}
        visible={showModalImagenes}
        onHide={() => {
          setShowModalImagenes(false);
        }}
        className="w-50"
      >
        <div>
          {/* {imagenes.NombreCompleto && ( */}
            <Carousel
              value={imagenes.img}
              circular
              showIndicators={true}
              itemTemplate={(item) => {
                return (
                  <div className="d-flex" style={{ justifyContent: "center", alignItems: "center", height: "600px"}}>
                    <img
                      src={"data:image/png;base64," + item}
                      alt="imagen"
                      style={{
                        maxWidth: "100%",
                        maxHeight: "100%",
                        objectFit: "contain",
                      }}
                    />
                  </div>
                );
              }}
            />
          {/* )} */}
        </div>
      </Dialog>
    </div>
  );
};

export default ImagenCRUD;
